import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useThemeStore } from '@/stores/theme';
import { TooltipProvider } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

/**
 * Logged-in root: Sidebar (fixed) | right column (topbar + main).
 * The `.dark` class lives on THIS node so the login screen keeps its palette.
 */
export function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  const theme = useThemeStore((s) => s.theme);

  return (
    <TooltipProvider>
      <div
        className={cn(
          'flex h-screen bg-s-bg font-sans text-s-text',
          theme === 'dark' && 'dark',
        )}
      >
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar />
          <main className="relative min-w-0 flex-1 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </TooltipProvider>
  );
}
